/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react'
import ReactPlayer from "react-player/youtube"
import { useDispatch, useSelector } from 'react-redux'
import { fetchLessonDetails, selectLessonDetails } from '../../redux/personaliseLessons/lessonDetailsSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from './utilities/constants'
import { setLastWatchedLesson } from '../../redux/personaliseLessons/nameSlice'
import { fetchUserActivityUpdate } from '../../redux/personaliseLessons/updateUserActivitySlice'
import { selectCourseList } from '../../redux/personaliseLessons/courseListSlice'
import { selectAuthentication } from '../../redux/personaliseLessons/authenticationSlice'
import 'rc-slider/assets/index.css';
import { fetchCourseModule } from '../../redux/personaliseLessons/courseModuleSlice'
import PlaceHolderImage from './PlaceHolderImage'
import Loader from './components/Loader'


const VideoPlayer = ({ lesson_slug, videoPlayerRef, showOnboardingOverview, handleUnlock, isModalLoading }) => {

    const dispatch = useDispatch()
    
    const lessonDetails = useSelector(selectLessonDetails)?.lesson_data
    const uid = useSelector(selectAuthentication)?.uid
    const subject_name = useSelector(selectCourseList)?.courseName
    
    function getVideoURL(url, startTime, stopTime) {

        const urlParams = url?.split('?').length

        if (startTime > 0 && stopTime > 0)
            return `${url}${urlParams > 1 ? `&start=${startTime}&end=${stopTime}` : `?start=${startTime}&end=${stopTime}`}`
        else if (startTime === 0 && stopTime > 0)
            return `${url}${urlParams > 1 ? `&end=${stopTime}` : `?end=${stopTime}`}`
        else if (startTime > 0 && stopTime === 0)
            return `${url}${urlParams > 1 ? `&start=${startTime}` : `?start=${startTime}`}`
        return url
    }

    const handleStart = () => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_LESSON_WAS_PLAYED)
        dispatch(setLastWatchedLesson({ lessonId: lessonDetails?.lesson_id}))
        if (lessonDetails?.lesson_status === ""){
            const fetchData = async () => {
                try {
                    await dispatch(fetchUserActivityUpdate({ uid: uid, subject: subject_name, lesson_id: lessonDetails?.lesson_id, status: "inprogress" }));
                    dispatch(fetchLessonDetails({ uid: uid, subject: subject_name, lesson_slug: lesson_slug }))
                    dispatch(fetchCourseModule({ uid: uid, subject_name }))
                }catch(error){
                    console.log(error.message);
                }
            }
            fetchData()
        }
    }

    const handleComplete = () => {
        if (lessonDetails?.lesson_status === "inprogress"){
            dispatch(fetchUserActivityUpdate({ uid: uid, subject: subject_name, lesson_id: lessonDetails?.lesson_id, status: "quizpending" }))
            dispatch(fetchCourseModule({ uid: uid, subject_name }))
        }
    }

    const handleProgress = useCallback((state) => {
        console.log(state.playedSeconds, "this is seconds")
        if (lessonDetails?.stop_time !== 0 && state.playedSeconds >= lessonDetails?.stop_time) {
            videoPlayerRef.current.seekTo(0)
            videoPlayerRef.current.pause()
        }
      }, [])



      if (!lessonDetails) {
        return <Loader/>
      }

    return (
        <div className='w-full lg:mx-auto lg:rounded-xl overflow-hidden flex flex-col items-center justify-center'>
            {showOnboardingOverview ? <PlaceHolderImage imageUrl={lessonDetails?.thumbnail_url} handleUnlock={handleUnlock} isModalLoading={isModalLoading}/> : <ReactPlayer
                url={getVideoURL(lessonDetails?.video_url, lessonDetails?.start_time, lessonDetails?.stop_time)}
                ref={videoPlayerRef}
                width={'100%'}
                onProgress={(e) => handleProgress(e)}
                onStart={handleStart}
                playing={true}
                controls={true}
                config={{
                    file: {
                        attributes: {
                            preload: 'auto',
                            poster : lessonDetails?.thumbnail_url,
                        },
                    },
                    youtube: {
                        playerVars: { modestbranding: 1, rel: 0 ,cc_load_policy:1 , cc_lang_pref:'en'},
                    },
                }}
                onEnded={handleComplete}
            />}       
        </div> 
    )
}

export default VideoPlayer